import type { ErrorBoundaryLabels } from "./error-boundary";

export interface ErrorScreenAction {
  label: string;
  onClick: () => void;
}

/**
 * The one screen for "this part of the application threw": a sentence, the event id when the SDK
 * assigned one, and a button that reloads. Inline styles rather than the design system, because it also
 * renders when the design system's own provider is what threw.
 */
export function ErrorScreen({
  eventId,
  labels,
  onReload,
  report,
}: {
  eventId?: string;
  labels: ErrorBoundaryLabels;
  onReload: () => void;
  /** "Report this error" (EP-53): only where the application has somewhere to send a report. */
  report?: ErrorScreenAction;
}) {
  return (
    <div
      role="alert"
      data-testid="error-boundary"
      style={{ maxWidth: 480, margin: "15vh auto", padding: "1.5rem", fontFamily: "system-ui, sans-serif", textAlign: "center" }}
    >
      <h1 style={{ fontSize: "1.25rem", fontWeight: 600, marginBottom: "0.5rem" }}>{labels.title}</h1>
      <p style={{ color: "#57534e", marginBottom: "1rem" }}>{labels.description}</p>
      {eventId ? (
        <p style={{ fontSize: "0.75rem", color: "#78716c", marginBottom: "1rem" }} data-testid="error-boundary-event-id">
          {labels.eventId}: <code>{eventId}</code>
        </p>
      ) : null}
      <button
        type="button"
        data-testid="error-boundary-reload"
        onClick={onReload}
        style={{ padding: "0.5rem 1rem", borderRadius: 6, border: "1px solid #a8a29e", background: "white", cursor: "pointer" }}
      >
        {labels.reload}
      </button>
      {report ? (
        <button
          type="button"
          data-testid="error-boundary-report"
          onClick={report.onClick}
          style={{ marginLeft: "0.5rem", padding: "0.5rem 1rem", borderRadius: 6, border: "1px solid #57534e", background: "#57534e", color: "white", cursor: "pointer" }}
        >
          {report.label}
        </button>
      ) : null}
    </div>
  );
}
